import { Box, Grid, Typography } from "@mui/material";

import SystemHealthSection from "../SystemHealthSection";
import ExecutiveKpiCard from "../ExecutiveKpiCard";
import DashboardTodoPanel from "../components/DashboardTodoPanel";
import { pick } from "../managementDashboardUtils";

const AssetsEnergyTab = ({
  analyticsLoading,
  growthAnalytics,
  smsSummary,
  overview,
  periodDays,
  setPeriodDays,
  executiveKpis,
  currencyUnit,
  kpiLoading,
}) => {
  const commissionedProjects = executiveKpis.find(
    (k) => pick(k, "code", "Code") === "CommissionedProjects"
  );
  const commissionedCapacity = executiveKpis.find(
    (k) => pick(k, "code", "Code") === "CommissionedCapacityKw"
  );

  return (
    <Box>
      <Typography fontWeight={700} fontSize={16} sx={{ mb: 1.5 }}>
        دارایی‌ها و انرژی
      </Typography>
      <Grid container spacing={1.5} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6} md={4}>
          <ExecutiveKpiCard
            kpi={commissionedProjects || {
              title: "نیروگاه‌های نصب‌شده",
              value: overview?.operatingPlants,
              unit: "پروژه",
              isAvailable: true,
              metricType: 2,
            }}
            currencyUnit={currencyUnit}
            loading={kpiLoading || analyticsLoading}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ExecutiveKpiCard
            kpi={commissionedCapacity || {
              title: "ظرفیت نصب‌شده",
              isAvailable: false,
              unavailableReason: "داده ظرفیت در KPI موجود نیست.",
            }}
            currencyUnit={currencyUnit}
            loading={kpiLoading}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ExecutiveKpiCard
            kpi={{
              title: "تولید واقعی",
              value: overview?.hasEnergyData ? overview?.totalEnergyProducedKwh : null,
              unit: "kWh",
              isAvailable: Boolean(overview?.hasEnergyData),
              unavailableReason: "داده تولید انرژی در سامانه ثبت نشده است.",
              metricType: 2,
            }}
            currencyUnit={currencyUnit}
            loading={analyticsLoading}
          />
        </Grid>
      </Grid>

      <DashboardTodoPanel
        title="پایش آنلاین و تخمین تولید"
        futureEndpoints={["GetInstalledAssetsSummary", "GetEnergyTimeseries"]}
        description="درصد پایش آنلاین، تولید تخمینی ماهانه و مقایسه تخمین با واقعی."
      />

      <SystemHealthSection
        analyticsLoading={analyticsLoading}
        growthAnalytics={growthAnalytics}
        smsSummary={smsSummary}
        overview={overview}
        periodDays={periodDays}
        onPeriodChange={setPeriodDays}
      />
    </Box>
  );
};

export default AssetsEnergyTab;
